<div *ngIf="hasPrintableAccess && (version == 'r7' || isR103) && isActive" class="printable-nav-tab">
	<span
		[ngClass]="[
			'printable-link',
			!sem_btnEnabled ? 'inactive' : '',
			!hasActiveCampaign ? 'inactive' : '',
			version == 'r6' && disableToolTip ? 'primary-color-bg-on-hover100' : '',
			version == 'r3' && sem_btnEnabled ? 'primary-color-bg' : ''
		]"
	>
		<a
			id="{{ version }}-{{ printableProductName }}-slidedeck"
			(click)="showWidgetModal()"
			tooltip="{{ toolTipMsg }}"
			tooltip-class="printable-tooltip"
			placement="top"
		>
			<span
				class="download_text"
				*ngIf="!overviewPrintableReport && !isR103"
				[ngClass]="{ 'secondary-color': sem_btnEnabled }"
				>Download Printable Report</span
			>
			<span
				class="download_text"
				*ngIf="overviewPrintableReport || isR103"
				[ngClass]="{ 'secondary-color': sem_btnEnabled }"
				>Printable Report</span
			>
		</a>
	</span>
</div>
